import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mitteilungs-vorlage-entfernen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungsVorlageEntfernenEffects {

    MitteilungsVorlageEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MITTEILUNGS_VORLAGE_ENTFERNEN),
        mergeMap((x: ac.PostMitteilungsVorlageEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMitteilungsVorlageEntfernen(x.mitteilungsVorlageRequest).pipe(
                map((result: any) => {
                    return new ac.PostMitteilungsVorlageEntfernenErfolgreichAction(result, x.mitteilungsVorlageRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMitteilungsVorlageEntfernenFehlerAction(error, x.mitteilungsVorlageRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageCommandService);
        }
        return this.service;
    }
}
